"use client"

import { useState } from "react"
import { editCartItemQuantity, removeItemFromCart } from "src/checkout/hooks/useCart"
import { NpSelect } from "src/components/np-design/components/input/NpSelect"
import { StorefrontCartItem } from "src/types/storefront"

export type QuantitySelectProps = {
  item: StorefrontCartItem
}

export const QuantitySelect = ({ item }: QuantitySelectProps) => {
  const [loading, setLoading] = useState(false)

  const limit = Math.min(item.low_stock_remaining ?? 9999, item.quantity_limits.maximum || 9999, 5)
  const displayedLimit = Math.max(limit, item.quantity || 0)
  const quantities = Array.from(
    Array(displayedLimit)
      .keys()
      .map((index) => index + 1),
  )

  return (
    <NpSelect
      placeholder=""
      autoComplete="off"
      loading={loading}
      options={quantities.map((quantity) => ({ value: quantity.toString(), label: quantity.toString() }))}
      value={item.quantity.toString()}
      onChange={async (value) => {
        setLoading(true)

        const quantity = +value

        if (quantity) {
          await editCartItemQuantity(item.key, quantity)
        } else {
          await removeItemFromCart(item.key)
        }

        setLoading(false)
      }}
    />
  )
}
